module.exports = __webpack_public_path__ + "static/media/news_bottom.a8b861d1.png";